import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { decryptData } from '../../../utils/encrypt';
import { UPDATE_PLANNING_PRIORTY, WABA_DISPATCH_TRIGGER } from '../../../config/api';

function PlanningTable({ orders, showDispatchButton = false, setOrders }) {
  const navigate = useNavigate();
  const [editPriorityId, setEditPriorityId] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateSize = () => setIsMobile(window.innerWidth < 768);
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const getUserInfo = () => {
    const encryptedUser = localStorage.getItem('suyog_user');
    if (!encryptedUser) return null;
    return decryptData(encryptedUser);
  };

  const handlePriorityChange = async (planning_id, newPriority) => {
    const user = getUserInfo();
    if (!user) return alert('Session expired');

    try {
      const res = await fetch(UPDATE_PLANNING_PRIORTY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ planning_id, priority: newPriority, updated_by: user.user_id })
      });
      const result = await res.json();
      if (result.success) {
        setOrders(prev =>
          prev.map(o => (o.planning_id === planning_id ? { ...o, priority: newPriority } : o))
        );
        setEditPriorityId(null);
      } else {
        alert(result.error || 'Failed to update');
      }
    } catch (err) {
      alert('Server error while updating priority');
    }
  };

  const handleCreateDispatch = (order) => {
    const user = getUserInfo();
    if (!user) return alert('Session expired. Please login again.');
    const { user_id, selected_org } = user;
    const org_id = selected_org?.value;
    if (!user_id || !org_id) return alert('Missing user or organization info.');

    const query = new URLSearchParams({ user_id, org_id, planning_id: order.planning_id }).toString();
    navigate(`/dispatchplanning?${query}`);
  };

  const handleEditDispatch = (order, dispatch_id) => {
    const user = getUserInfo();
    if (!user) return alert('Session expired. Please login again.');
    const { user_id, selected_org } = user;
    const org_id = selected_org?.value;
    if (!user_id || !org_id) return alert('Missing user or organization info.');

    const query = new URLSearchParams({ user_id, org_id, dispatch_id }).toString();
    navigate(`/edit-dispatch?${query}`);
  };


  const handleSendWaba = async (dispatch_id) => {
  try {
    const res = await fetch(WABA_DISPATCH_TRIGGER, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ dispatch_id })
    });

    const result = await res.json();
    if (result.success) {
      alert('✅ WABA message sent successfully.');
    } else {
      alert(result.error || '❌ Failed to send WABA message.');
    }
  } catch (err) {
    console.error('WABA send error:', err);
    alert('❌ Server error while sending WABA message.');
  }
};


  if (isMobile) {
    return (
      <div className="container">
        {orders.map(order => {
          const dispatches = Array.isArray(order.dispatches) ? order.dispatches : [];
          const totalVehicleQty = dispatches.reduce((sum, d) => sum + parseFloat(d?.vehicle_qty || 0), 0);
          const invoicedQty = dispatches.reduce((sum, d) => d?.is_invoiced ? sum + parseFloat(d?.vehicle_qty || 0) : sum, 0);
          const plannedQty = parseFloat(order.planned_qty || 0);
          const balanceQty = plannedQty - totalVehicleQty;
          const canAddVehicle = balanceQty > 0.001;
          const hasInvoice = (order.invoice_item_ids || []).length > 0;

          return (
            <div key={order.planning_id} className="card mb-3 shadow-sm border-primary border">
              <div className="card-body">
                <h6 className="card-title text-primary">{order.material_name} @ ₹{order.so_price} ({order.unit})</h6>
                <ul className="list-group list-group-flush small">
                  <li className="list-group-item"><strong>Customer:</strong> {order.customer_name}</li>
                  <li className="list-group-item"><strong>PO No:</strong> {order.customer_po_no}</li>
                  <li className="list-group-item"><strong>Delivery Date:</strong> {order.delivery_date}</li>
                  <li className="list-group-item">
  <strong>Destination:</strong> {order.destination || '-'}
</li>

<li className="list-group-item">
  <strong>Address:</strong> {order.destination_address || '-'}
</li>

<li className="list-group-item">
  <strong>Destination Remark:</strong> {order.destination_remark || '-'}
</li>
                  <li className="list-group-item"><strong>Packing Style:</strong> {order.packing_style}</li>
                  <li className="list-group-item"><strong>Planned Qty:</strong> {plannedQty.toFixed(3)} {order.unit}</li>
                  <li className="list-group-item"><strong>Vehicle Qty:</strong> {totalVehicleQty.toFixed(3)} MT</li>
                  <li className="list-group-item"><strong>Invoiced Qty:</strong> {invoicedQty.toFixed(3)} MT</li>
                  <li className="list-group-item"><strong>Balance Qty:</strong> {balanceQty.toFixed(3)} MT</li>
                  <li className="list-group-item"><strong>Priority:</strong> {order.priority}</li>
                  <li className="list-group-item"><strong>SO Remark:</strong> {order.so_remark || '-'}</li>
                  <li className="list-group-item"><strong>Planning Remark:</strong> {order.sop_remark || '-'}</li>
                </ul>

                {dispatches.map((d, idx) => (
                  <div key={d?.id || idx} className="border-top pt-2 mt-2">
                    <div className="fw-semibold mb-1">Dispatch #{idx + 1}</div>
                    <div className="small text-muted mb-1"><strong>Date:</strong> {d?.dispatch_date || '-'} | <strong>Vehicle:</strong> {d?.vehicle_no}</div>
                    <div className="small text-muted mb-1"><strong>Driver:</strong> {d?.driver_name} - {d?.driver_mobile}</div>
                    <div className="small text-muted mb-1"><strong>Diesel:</strong> {parseFloat(d?.diesel_ltr || 0).toFixed(2)} Ltr | <strong>Cash:</strong> ₹{parseFloat(d?.cash_amount || 0).toFixed(2)}</div>
                    <div className="small text-muted mb-1"><strong>Remark:</strong> {d?.remark}</div>
                    <div className="small text-muted mb-2"><strong>Vehicle Qty:</strong> {parseFloat(d?.vehicle_qty || 0).toFixed(3)} MT</div>
                   {d?.is_invoiced ? (
  <>
    <button className="btn btn-sm btn-secondary w-100" disabled>
      🧾 Invoice Generated
    </button>
    <button
      className="btn btn-sm btn-outline-success mt-1 w-100"
      onClick={() => handleSendWaba(d.id)}
    >
      📤 Send WABA
    </button>
  </>
) : (
  <>
    <button
      className="btn btn-sm btn-outline-secondary w-100"
      onClick={() => handleEditDispatch(order, d.id)}
    >
      Edit Dispatch
    </button>
    <button
      className="btn btn-sm btn-outline-success mt-1 w-100"
      onClick={() => handleSendWaba(d.id)}
    >
      📤 Send WABA
    </button>
  </>
)}

                  </div>
                ))}

                {showDispatchButton && (
                  canAddVehicle ? (
                    <button className="btn btn-sm btn-primary mt-3 w-100" onClick={() => handleCreateDispatch(order)}>
                      ➕ Add Vehicle
                    </button>
                  ) : (
                    <div className="text-muted small mt-2 text-center">
                      <i className="bi bi-check-circle text-success me-1"></i>
                      No further vehicle required.
                    </div>
                  )
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
  return (
    <div className="container-fluid">
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-sm small align-middle">
          <thead className="table-light small">
            <tr className="text-center">
              <th>Planning ID</th>
              <th>Customer</th>
              <th>PO No</th>
              <th>Delivery Date</th>
              <th>Destination</th>
              <th>Material</th>
              <th>Packing Style</th>
              <th>Planned Qty</th>
              <th>Priority</th>
              <th>Created On</th>
              <th>Updated On</th>
              <th>SO Remark</th>
              <th>Planning Remark</th>
              <th>Vehicle Planning</th>
              <th>Change Priority</th>
              {showDispatchButton && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {orders.map(order => {
              const dispatches = Array.isArray(order.dispatches) ? order.dispatches : [];
              const totalVehicleQty = dispatches.reduce((sum, d) => sum + parseFloat(d?.vehicle_qty || 0), 0);
              const invoicedQty = dispatches.reduce((sum, d) => d?.is_invoiced ? sum + parseFloat(d?.vehicle_qty || 0) : sum, 0);
              const plannedQty = parseFloat(order.planned_qty || 0);
              const balanceQty = plannedQty - totalVehicleQty;
              const canAddVehicle = balanceQty > 0.001;
              const hasInvoice = (order.invoice_item_ids || []).length > 0;

              return (
                <tr key={order.planning_id} className="text-center">
                  <td>{order.planning_id}</td>
                  <td>{order.customer_name}</td>
                  <td>{order.customer_po_no}</td>
                  <td>{order.delivery_date}</td>
                 <td>
  <strong>{order.destination || '-'}</strong>
  <br />

  <small className="text-muted">
    <strong>Address:</strong>{' '}
    {order.destination_address || '-'}
  </small>

  <br />

  <small className="text-muted">
    <strong>Remark:</strong>{' '}
    {order.destination_remark || '-'}
  </small>
</td>
                  
                  <td>{order.material_name} @ {order.so_price}</td>
                  <td>{order.packing_style}</td>
                  <td>
                    <div className="text-muted small">
                      <div>SO Planned Qty: <strong>{plannedQty.toFixed(3)} {order.unit}</strong></div>
                      <div>Vehicle Placement Qty: <strong>{totalVehicleQty.toFixed(3)} MT</strong></div>
                      <div>Invoiced Qty: <strong>{invoicedQty.toFixed(3)} MT</strong></div>
                     
                    </div>
                  </td>
                  <td>{order.priority}</td>
                  <td>{order.plan_created_on}<br />{order.created_by_name}</td>
                  <td>{order.plan_updated_on}<br />{order.updated_by_name}</td>
                  <td>{order.so_remark || '-'}</td>
                  <td>{order.sop_remark || '-'}</td>
                  <td>
                    {dispatches.map((d, idx) => (
                      <div key={d?.id || idx} className="mb-2">
                        <div><strong>Vehicle Planning Date:</strong> {d?.dispatch_date || '-'}</div>
                        <div><strong>Vehicle:</strong> {d?.vehicle_no || '-'}</div>
                        <div><strong>Driver:</strong> {d?.driver_name || '-'} - {d?.driver_mobile || '-'}</div>
                        <div><strong>Diesel:</strong> {parseFloat(d?.diesel_ltr || 0).toFixed(2)} Ltr</div>
                        <div><strong>Cash:</strong> ₹{parseFloat(d?.cash_amount || 0).toFixed(2)}</div>
                        <div><strong>Remark:</strong> {d?.remark || '-'}</div>
                        <div><strong>Vehicle Planning Qty:</strong> {parseFloat(d?.vehicle_qty || 0).toFixed(3)} MT</div>
                       {d?.is_invoiced ? (
  <>
    <button className="btn btn-sm btn-secondary mt-1" disabled>
      🧾 Invoice Generated
    </button>
    <button
      className="btn btn-sm btn-outline-success mt-1"
      onClick={() => handleSendWaba(d.id)}
    >
      📤 Send WABA
    </button>
  </>
) : (
  <>
    <button
      className="btn btn-sm btn-outline-secondary mt-1"
      onClick={() => handleEditDispatch(order, d.id)}
    >
      Edit Dispatch....
    </button>
    <button
      className="btn btn-sm btn-outline-success mt-1"
      onClick={() => handleSendWaba(d.id)}
    >
      📤 Send WABA
    </button>
  </>
)}
                        {idx < dispatches.length - 1 && <hr />}
                      </div>
                    ))}
                  </td>
                  <td>
                    {hasInvoice ? (
                      <span className="text-muted small">Locked<br />(Invoice Generated)</span>
                    ) : order.dispatches?.length ? (
                      <span className="text-muted small">Locked<br />(Vehicle Planned)</span>
                    ) : editPriorityId === order.planning_id ? (
                      <select
                        className="form-select form-select-sm"
                        value={order.priority || ''}
                        onChange={(e) => handlePriorityChange(order.planning_id, e.target.value)}
                        onBlur={() => setEditPriorityId(null)}
                      >
                        <option value="">-- Select --</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                        <option value="On Hold">On Hold</option>
                      </select>
                    ) : (
                      <button className="btn btn-sm btn-outline-primary" onClick={() => setEditPriorityId(order.planning_id)}>Change</button>
                    )}
                  </td>
                  {showDispatchButton && (
                    <td>
                      {canAddVehicle ? (
                        <button className="btn btn-sm btn-primary" onClick={() => handleCreateDispatch(order)}>
                          Add Vehicle
                        </button>
                      ) : (
                        <div className="text-muted small">
                          <i className="bi bi-check-circle text-success me-1"></i>
                          No further vehicle required.
                        </div>
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PlanningTable;
  